enum ShowDevice {
    ALL = 'ALL',
    ONLY_PAIRED = 'ONLY_PAIRED',
    ONLY_NOT_PAIRED = 'ONLY_NOT_PAIRED'
}

export default ShowDevice;
